import React from "react";
import { Contract } from "@ethersproject/contracts";
import stakingAbi from "../utils/stakingAbi.json";
import SalesABI from "../utils/saleContract.json";
import busdABI from "../utils/busdAbi.json";

import galaxyPadAbi from "../utils/galaxyPadAbi.json";
import {
  stakingAddress,
  saleContractAddress,
  galaxyPadTokenAddress,
  busdAddress,
} from "../utils/environment";
import Web3 from "web3";
import { LinearProgress, linearProgressClasses } from "@mui/material";
import styled from "@emotion/styled";

const web3 = new Web3(
  Web3.givenProvider
    ? Web3.givenProvider
    : "https://data-seed-prebsc-1-s1.binance.org:8545"
);
function useContract(address, ABI, signer) {
  return React.useMemo(() => {
    if (signer) {
      return new Contract(address, ABI, signer);
    } else {
      return "error";
    }
  }, [address, ABI, signer]);
}
export function useGalaxyTokenContract(signer) {
  return useContract(galaxyPadTokenAddress, galaxyPadAbi, signer);
}
export function useStakingContract(signer) {
  return useContract(stakingAddress, stakingAbi, signer);
}
export function UseSalesContract(signer) {
  return useContract(saleContractAddress, SalesABI, signer);
}
export function useBusdContract(signer) {
  return useContract(busdAddress, busdABI, signer);
}
export function UseSalesContractWeb3() {
  try {
    const saleContract = new web3.eth.Contract(SalesABI, saleContractAddress);
    return saleContract;
  } catch (error) {}
}
export function useGalaxyContractWeb3() {
  try {
    const galaxyContract = new web3.eth.Contract(
      galaxyPadAbi,
      galaxyPadTokenAddress
    );
    return galaxyContract;
  } catch (error) {}
}
export function useStakingContractWeb3() {
  try {
    const stakingContract = new web3.eth.Contract(stakingAbi, stakingAddress);
    return stakingContract;
  } catch (error) {}
}

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  width: "100%",
  borderRadius: 25,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "gray",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 25,
    background: "linear-gradient(360deg, #26058E 50%, #A301F7)",
  },
}));
